import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-side-by-side';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';

const btnInside = buttonPrimary({
  radius: 100,
  backgroundColor: '#AD4870',
  text: 'Try tt today, risk-free !',
  link: '#',
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f75278ef7f96fb5018d5.png',
  },
  policy: {
    show: true,
    colPerView: 2,
    alignContent: 'left',
    items: [
      {
        icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f7553bebcf1f6fc58638.png',
        text: '30-DAY MONEY-BACK GUARANTEE',
      },
      {
        icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f758c489b3767e33b446.png',
        text: 'FREE RETURNS, NO QUESTIONS ASKED',
      },
    ],
  },
});

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="wrap-card">
    <div
      class="left-card"
      data-attribute="left-card"
      data-use-custom-width="true"
      data-custom-width="585"
      data-order="1"
      data-use-vid="true"
      style="--left-order: 1; --custom-width: 585px;"
    >
      <div class="wrap-media">
        <img data-attribute="img-left" src="" alt="" style="display: none;" />
        <video
          data-attribute="video-left"
          src="https://cdn-cf-east.streamable.com/video/mp4/qazxij.mp4?Expires=1787365526529&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ&Signature=TYtmZ6VAtQ5qDVAnoLfDJzp~C7roMeT6qXtA5FYBM6-vQBUq6DRH3Bh8~RaRTOqYwTYWsM8a6IjG54Q5K3UHEbcU7j5p9AScZnOe3xXMUwkfKJ~~8f6s1X37NfkDUU00jsOoqk-au0OrkPmlKYv8b87cRO31IdT7bf5cC8-y9nm0nAuSAlaf94gSFpcJbaAKuEPkTTLcPSx4FhONvakOG1xxwIt6DjiIFpJLp0mj64gyNUi6QLQpi1Iwi8jW1IKBsS5QSzjufYSLDH-A0Fyn7hHjQ3aP8yZz3WFAuo6ZltYFEticFYhmlNU4asdnIiyD5nJ7EA3CNK85TOLeAgTc0w__"
          autoplay
          loop
          muted
          playsinline
          style="display: block;"
        ></video>
      </div>
    </div>
    <div
      class="right-card"
      data-bg-content="#FCF8F9"
      data-attribute="right-card"
      data-order="2"
      style="--right-order: 2; --bg-content: #FCF8F9;"
    >
      <div data-show="true" class="heading-content" data-attribute="heading-content">
        <h2>Define Your Contour - Own Your Contour.</h2>
        <p>
          At CalyraFit, we believe contour is personal. Enhance your natural curves and colliine your contour technology
          confliote and converiment.
        </p>
      </div>

      <div
        class="stats-group"
        data-show="true"
        data-attribute="stats-group"
        data-bg-stats-group="#ffffff"
        data-color-border="#FFD0DB"
        style="--bg-stats-group:#ffffff; --color-border:#FFD0DB"
      >
        <div class="stats-group-item" data-attribute="stats-group-item">
          <h3>47+</h3>
          <p>
            Pressure <br />
            points
          </p>
        </div>
        <div class="stats-group-item" data-attribute="stats-group-item">
          <h3>8h</h3>
          <p>
            Passive <br />
            treatment
          </p>
        </div>
        <div class="stats-group-item" data-attribute="stats-group-item">
          <h3>30%</h3>
          <p>
            Circulation <br />
            boost
          </p>
        </div>
      </div>

      <div
        class="list-pill"
        data-attribute="list-pill"
        data-show="true"
        data-bg-pill="#ffffff"
        data-color-border="#FFD0DB"
        style="--bg-pill:#ffffff; --color-border: #ffd0db;"
      >
        <div class="pill-item" data-attribute="pill-item">
          Shape your waist
        </div>
        <div class="pill-item" data-attribute="pill-item">
          Support your curves
        </div>
        <div class="pill-item" data-attribute="pill-item">
          Move with confidence
        </div>
      </div>

      <div
        class="feature-callout"
        data-attribute="feature-callout"
        data-color-line="#AD4870"
        data-show="true"
        style="--color-line:#AD4870"
      >
        <h3>The right pressure. In the right places.</h3>
        <p>
          Compression stockings squeeze everything uniformly, you count the hours until you can take them off.
          CalyraFit™ activates only where lymphatic drainage needs it. The rest of the fabric breathes freely. You
          forget you're wearing a treatment at all.
        </p>
      </div>

      <div
        class="testimonial"
        data-attribute="testimonial"
        data-show="true"
        data-color-highlight="#FFD0DB"
        style="--color-highlight: #FFD0DB;"
      >
        <div class="avatar">
          <img data-attribute="avatar-expert" src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f74c34065eba14130948.png" alt="" />
        </div>
        <div class="testimonial-content" data-attribute="testimonial-content">
          <h4>
            "CalyraFit™ replicates what manual lymphatic drainage achieves, passively, continuously, without any effort
            from the wearer."
          </h4>
          <p>— Dr. Rebecca Simmons, Board-Certified Dermatologist</p>
        </div>
      </div>

      <div data-attribute="wrap-btn-dynamic" class="wrap-btn">
        ${btnInside}
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
